/**
 * The prototype's "+ Add element" page-head button (f11.2). Rendered only
 * when the server says `can_add_element`; the POST re-checks everything, so
 * hiding it is presentation, never the boundary.
 */

import { useState } from 'react';
import { Plus } from 'lucide-react';

import type { ForecastGrid } from '@/api/client';

import { AddElementModal } from './AddElementModal';

export function AddElementButton({ grid, onAdded }: { grid: ForecastGrid; onAdded: (elementCode: string) => void }) {
  const [open, setOpen] = useState(false);
  if (!grid.can_add_element) return null;
  return (
    <>
      <button type="button" className="btn btn-secondary" onClick={() => setOpen(true)}>
        <Plus aria-hidden="true" /> Add element
      </button>
      {open && (
        <AddElementModal
          cycleId={grid.cycle.id}
          cycleCode={grid.cycle.code}
          businessUnitId={grid.business_unit.id}
          businessUnitName={grid.business_unit.name}
          onClose={() => setOpen(false)}
          onAdded={(code) => {
            setOpen(false);
            onAdded(code);
          }}
        />
      )}
    </>
  );
}
